var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Cascader',{attrs:{"placeholder":_vm.placeholder,"data":_vm.dataList,"disabled":_vm.disabled},on:{"on-change":_vm.cityChange},model:{value:(_vm.modelArr),callback:function ($$v) {_vm.modelArr=$$v},expression:"modelArr"}})
}
var staticRenderFns = []

export { render, staticRenderFns }